import { useEffect, useState } from 'react';
import axios from 'axios';
import '../App.css';
import { motion } from 'framer-motion';

function Header() {
  const [headerData, setHeaderData] = useState({
    logo_image: '',
    button_text: '',
    button_link: '#'
  });
  const [showBooking, setShowBooking] = useState(false);
  useEffect(() => {
    axios
      .get('https://family-barbers.com/wp-json/acf/v3/pages/14')
      .then((res) => {
        setHeaderData(res.data.acf);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <div id="header" className="section">
      <div className='logo-container'>
        {headerData.logo_image && (
          <img className='logo' alt='logo' src={headerData.logo_image.url} />
        )}
      </div>
      <div className='schedule-container'>
        <motion.button
          className='schedule-appointment'
          whileInView={{ y: 0, opacity: 1 }} // animate into place when visible
          initial={{ x: -200, opacity: 1 }}       // Start off-screen left
          animate={{ x: 0, opacity: 1 }}          // End in place, fully visible
          transition={{ duration: 0.8, ease: "easeOut" }} // Animation settings
          onClick={() => {
            if (window.innerWidth < 1024) {
              window.open("https://getsquire.com/booking/brands/family-barbers", "_blank");
            } else {
              setShowBooking(!showBooking);
            }
          }}
        >
          <div className='schedule-appointment-text'>
            {headerData.button_text || 'SCHEDULE APPOINTMENT'}
          </div>
        </motion.button>
      </div>

      {/* Booking Popup */}
      {showBooking && (
        <div className="booking-modal">
          <div className="booking-content">
            <button className="close-btn" onClick={() => setShowBooking(!showBooking)}>
              ✖
            </button>
            <iframe
              src="https://getsquire.com/booking/brands/family-barbers"
              style={{ width: "100%", height: '95vh', border: "none" }}
              title="Squire Booking"
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
}

export default Header;
